import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarModal_vue_vue_type_script_setup_true_lang_default, { useModal } from "./ScalarModal.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                */
//#region src/components/ScalarModal/ScalarModal.vue
var ScalarModal_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarModal_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-b002945c"]]);
//#endregion
export { ScalarModal_default as default, useModal };

//# sourceMappingURL=ScalarModal.vue.js.map